import React from 'react';

import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';

import {ChatWebsocketProvider} from './ChatWebsocketProvider';
import {KnowledgebaseChat} from './KnowledgebaseChat';
import {ToggleChatButton} from './ToggleChatButton';

import {selectIsHidingChat, toggleChat} from '../slice';

import type {RootState} from '../store/ChatAppStore';

export const ChatEnabler = () => {
  const dispatch = useDispatch();
  const url = window.SweetProcessVariables?.kburl;
  const kbId = window.SweetProcessVariables?.kbid;

  const isHidingChat = useSelector<RootState>((state) => {
    // hide chat until we have a URL we can look up in state to prevent flash.
    return url == null ? true : selectIsHidingChat(state, url);
  });

  if (kbId == null || url == null) {
    return null;
  }

  return (
    <FloatingChatBoxContainer
      glassBackground={!isHidingChat}
      className="position-fixed d-flex flex-row justify-content-end align-items-end m-auto"
    >
      <ChatWebsocketProvider>
        {!isHidingChat ? (
          <FloatingChatBox className="border-rounded d-flex flex-column align-items-stretch justify-content-start px-1 py-0">
            <KnowledgebaseChat
              knowledgebaseId={kbId}
              toggleWidget={() => {
                dispatch(toggleChat({url}));
              }}
            ></KnowledgebaseChat>
          </FloatingChatBox>
        ) : (
          <ToggleChatButton
            toggleWidget={() => {
              dispatch(toggleChat({url}));
            }}
          />
        )}
      </ChatWebsocketProvider>
    </FloatingChatBoxContainer>
  );
};

const FloatingChatBoxContainer = styled.div<{
  glassBackground: boolean;
}>`
  right: 0;
  bottom: 0;
  z-index: 9999999999;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: ${({glassBackground}) =>
    glassBackground ? 'blur(10px)' : 'none'};

  /* Mobile styles */
  @media (max-width: 768px) {
    left: 0;
    right: 0;
    width: 100%;
    justify-content: center;
  }
`;

const FloatingChatBox = styled.div`
  box-shadow: rgba(0, 0, 0, 0.05) 0 0 0 1px, rgb(241, 243, 245) 0 5px 20px 0,
    rgba(0, 0, 0, 0.05) 0 3px 3px 0;
  width: 400px;
  min-height: 100px;
  animation: popup-scaling 0.4s ease forwards;

  @keyframes popup-scaling {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    50% {
      transform: scale(1.2);
      opacity: 0.5;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  /* Mobile styles */
  @media (max-width: 768px) {
    min-width: auto;
    width: 100%;
    max-width: 100%;
    border-radius: 5px 5px 0 0;
    max-height: 70vh;
    box-shadow: rgba(0, 0, 0, 0.15) 0 0 10px 0;
  }
`;
